<template>
  <div
    class="Projects w-full h-screen bg-black text-white flex items-center justify-center content-center leading-loose"
  >
    <h1 class="text-transparent fixed">Architect Serving Launceston and Devonport</h1>
    <template
      v-for="project in projects"
    >
      <transition name="fade" :key="project.index">
        <div
          v-if="currentProject===project"
          :key="project.index"
          :style="{ backgroundImage: 'url(' + project.heroSrc + ')' }"
          class="absolute bg-cover bg-center w-full h-full bg-black"
        >
        </div>
      </transition>
    </template>
    <div class="w-1/2 flex flex-wrap items-center justify-center">
      <h3
        @mouseover="currentProject = project"
        @mouseleave="currentProject = null"
        @click="goToProject(project)"
        v-for="(project, index) in projects" :key="index + 'name'"
        class="text-center cursor-pointer transform hover:scale-110 duration-100 ease-in-out mr-0 md:mr-8 text-xl md:text-3xl leading-none mb-6 md:leading-loose md:mb-0"
        :class="{
        }"
      >
        {{project.name}}.
      </h3>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

export default {
  name: 'journal',
  components: {
  },
  metaInfo () {
    return {
      title: 'Architecture in Devonport & Launceston | Starbox Architecture',
      meta: [
        {
          name: 'description',
          content: 'Starbox Architecture is a team of Devonport-based architects that serve individuals around Launceston. Visit us online to get started!'
        },
        {
          name: 'keywords',
          content: 'starbox,architecture,starbox architecture,tasmania,tasmanian,tasmanian architecture,tasmania architecture'
        }
      ]
    }
  },
  data () {
    return {
      currentProject: null,
      projects: []
    }
  },
  computed: {
  },
  beforeDestroy () {
  },
  methods: {
    goToProject (project) {
      this.$router.replace('/journalentry/' + project.id)
    },
    getJournal () {
      var toReturn = []
      axios.get(process.env.VUE_APP_ROOT_API + '/journals').then(response => {
        var data = response.data
        for (var i = 0; i < data.length; i++) {
          toReturn.push({
            id: data[i].id,
            name: data[i].name,
            subHeading: data[i].sub_heading,
            description: data[i].description,
            items: data[i].items
          })
          if (data[i].hero_image) toReturn[i].heroSrc = data[i].hero_image.path
        }
        this.projects = toReturn
      }).catch(error => {
        console.log('Error', error)
      })
    }
  },
  created () {
  },
  mounted () {
    this.getJournal()
  }
}
</script>

<style lang="scss">
  $sm: '640px';
  $md: '768px';
  $lg: '1024px';
  $xl: '1280px';
  $xxl: '1920px';

</style>
